import { render, staticRenderFns } from "./MyAcademyUsers.vue?vue&type=template&id=138a23a2&scoped=true"
import script from "./MyAcademyUsers.vue?vue&type=script&lang=js"
export * from "./MyAcademyUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a23a2",
  null
  
)

export default component.exports